import axios from '@/libs/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libs/react-query';
import { useQuery } from '@tanstack/react-query';
import { Urls } from '../constant';

interface Request {
  id: number;
}

interface Assets {
  over: string;
  lock: string;
}

interface Response {
  data: Record<string, Assets>;
  status: number;
}

//
const request = (data: Request): Promise<Response> => {
  return axios.post(Urls.balanceUrl, {
    user_id: data.id,
  });
};

type QueryFnType = typeof request;
//
type UseRequestOptions = {
  id: number;
  config?: QueryConfig<QueryFnType>;
};

export const useBalance = ({ id, config }: UseRequestOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['user-assets', id],
    queryFn: () => request({ id }),
  });
};
